<template>
  <div class="dashboard">
    <div class="title">生物质及木材热分解动力学参数多模式可视化求解软件V1.0 <a class="readme" href="https://pan.baidu.com/s/1smMwpOh" target="_blank">软件说明</a></div>
    <div class="flex-container column">
      <div class="item input border1">
        <div class="border1">
          <Row>
            <div style="font-size: 18px; color: white; background-color: #2d8cf0">设置转化率 α</div>
          </Row>
          <Row style="margin-top: 12px;">
            <i-col span="8">起始值</i-col>
            <i-col span="8">最大值</i-col>
            <i-col span="8">间隔值</i-col>
          </Row>
          <Row style="margin-top: 6px;" :gutter="16">
            <i-col span="8">
              <Input-number size="small" :step="0.1" v-model="convRate.min"></Input-number>
            </i-col>
            <i-col span="8">
              <Input-number size="small" :step="0.1" v-model="convRate.max"></Input-number>
            </i-col>
            <i-col span="8">
              <Input-number size="small" :step="0.01" v-model="convRate.step"></Input-number>
            </i-col>
          </Row>
        </div>
        <div class="border1">
          <Row style="margin-top: 12px;">
            <i-col span="10"><label for="fa">机理方程</label></i-col>
            <i-col span="14">
              <Select id="fa" size="small" v-model="reactionFunc" @on-change="onSelectChange">
                <Option v-for="(item, index) in jilifuncs" :value="index" :key="item.name">{{item.name}}</Option>
              </Select>
            </i-col>
          </Row>
          <hr v-show="showMNInput" style="margin-top: 6px; border: 1px solid lightblue"/>
          <Row v-show="showMNInput" style="margin-top: 12px;">
            <i-col span="10" offset="2">
              <label>n</label>&nbsp;&nbsp;<Input-number size="small" v-model="jilifuncValueN" style="margin-top: -6px;"></Input-number>
            </i-col>
            <i-col span="12">
              <label>m</label>&nbsp;&nbsp;<Input-number size="small" v-model="jilifuncValueM" style="margin-top: -6px;"></Input-number>
            </i-col>
          </Row>
        </div>
        <div class="border1" style="vertical-align: middle">
          <Row style="margin-top: 12px;">
            <i-col span="8"><label for="ma">中间升温速率</label></i-col>
            <i-col span="16">
              <Input-number id="ma" size="small" v-model="middleHeatRate" style="width: 100%; margin-top: -6px;"></Input-number>
            </i-col>
          </Row>
        </div>
        <div class="border1">
          <Row>
            <div style="font-size: 20px; color: white; background-color: #2d8cf0">实验数据导入</div>
          </Row>
          <p style="text-align: justify; margin-top: 6px;">备注： 数据excel表格值依次为： 时间(min)， 温度(°C)， 重量(mg)， 重量微分(%/°C) </p>
          <Row style="margin-top: 12px;" :gutter="4" v-for="(item, index) in heatRates" :key="index">
            <i-col span="6">升温速率</i-col>
            <i-col span="6">
              <Input-number size="small" v-model="item.heatRate"></Input-number>
            </i-col>
            <i-col span="4">
              <Badge dot :count=" item.init ? '0' : '1' ">
                <xlsx-importer :heatRate="item.heatRate" @on-select-file="handleSelectedFile"></xlsx-importer>
              </Badge>
            </i-col>
            <i-col span="4">
              <Button size="small" :disabled="heatRates.length <= 1" @click="removeHeatingRate(index)">删除</Button>
            </i-col>
            <i-col span="4">
              <Button size="small" @click="addHeatingRate" v-if="index === heatRates.length - 1">增加</Button>
            </i-col>
          </Row>
        </div>
        <div style="margin: 20px 0;">
          <Row>
            <i-col span="24">
              <Tooltip content="计算最佳机理方程">
                <Button :disabled="disableCalculateJili" size="large" type="primary" @click="calculateJili" :loading="loadingJili">机理方程</Button>
              </Tooltip>
              <Button :disabled="disableCalculate" size="large" type="primary" @click="calculate" :loading="loading">运&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;算</Button>
            </i-col>
          </Row>
        </div>
      </div>
      <div class="item output border1">
        <Tabs :animated="false" style="padding: 10px 15px;">
          <TabPane label="活化能">
            <div class="chart-container">
              <highcharts :options="e0Options" ref="highchartsE0"></highcharts>
            </div>
          </TabPane>
          <TabPane label="指前因子">
            <div class="chart-container">
              <highcharts :options="preFactorOptions" ref="highchartsPreFactor"></highcharts>
            </div>
          </TabPane>
          <TabPane label="TG">
            <div class="chart-container">
              <highcharts :options="tgOptions" ref="highchartsTg"></highcharts>
            </div>
          </TabPane>
          <TabPane label="DTG">
            <div class="chart-container">
              <highcharts :options="dtgOptions" ref="highchartsDtg"></highcharts>
            </div>
          </TabPane>
          <TabPane label="转化率">
            <div class="chart-container">
              <highcharts :options="convRateOptions" ref="highchartsConvRate"></highcharts>
            </div>
          </TabPane>
          <TabPane label="dα/dt-T">
            <div class="chart-container">
              <highcharts :options="dadttOptions" ref="highchartsDadtT"></highcharts>
            </div>
          </TabPane>
          <TabPane label="斜率图">
            <div class="chart-container">
              <highcharts :options="dadt1tOptionsFM" ref="highchartsDadt1T"></highcharts>
            </div>
          </TabPane>
          <TabPane label="斜率图">
            <div class="chart-container">
              <highcharts :options="dadt1tOptionsFwo" ref="highchartsDadt1T"></highcharts>
            </div>
          </TabPane>
          <TabPane label="斜率图">
            <div class="chart-container">
              <highcharts :options="dadt1tOptionsKas" ref="highchartsDadt1T"></highcharts>
            </div>
          </TabPane>
          <TabPane label="最佳机理方程">
            <div class="chart-container" style="text-align: left">
              <div style="margin: 10px;"><b>以Ea为准排序</b>&nbsp;&nbsp;<Button style="float: right" size="small" type="dashed" @click="exportData(1)">导出</Button></div>
              <Scroll><Table ref="table1" :columns="columnsEa" :data="dataEa"></Table></Scroll>
              <div style="margin: 10px;"><b>以LnA为准排序</b>&nbsp;&nbsp;<Button style="float: right" size="small" type="dashed" @click="exportData(2)">导出</Button></div>
              <Scroll><Table ref="table2" :columns="columnsLnA" :data="dataLnA"></Table></Scroll>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import xlsxImporter from './xlsx-importer'
  import equation from './equation'
  import {
    fetchNearestRateDatasForFixedRate,
    fetchFwoSlopDatasForFixedRate,
    fetchKasSlopDatasForFixedRate,
    fetchFMSlopDatasForFixedRate,
    calculateLnAandNForFuntion43,
    nearestRateData,
    fitLine,
    calculateHxFwo,
    calculateHxKas
  } from './calculate'

  const B1 = 0.4567;
  const CONST_R = 8.314;
  const KNOWN_REACTION_LEVEL_FUN_IDX = 40;

  export default {
    name: 'dashboard',
    components: { xlsxImporter },
    data () {
      return {
        showMNInput: false,
        jilifuncValueN: 1,
        jilifuncValueM: 0,
        disableCalculate: false,
        disableCalculateJili: false,
        dataEa: [],
        dataLnA: [],
        columnsEa: [{title: '升温速率', key: 'heatRate'},{title: '机理函数', key: 'name'},{title: '误差', key: 'error'}],
        columnsLnA: [{title: '升温速率', key: 'heatRate'},{title: '机理函数', key: 'name'},{title: '误差', key: 'error'}],
        loading: false,
        loadingJili: false,
        jilifuncs: equation.mechanisms,
        convRate: { min: 0.2, max: 0.8, step: 0.05 },
        reactionFunc: 32,
        middleHeatRate: 10,
        heatRates: this.$store.state.heatRates,
        e0Options: equation.default_high_charts_option,
        tgOptions: equation.default_high_charts_option,
        dtgOptions: equation.default_high_charts_option,
        convRateOptions: equation.default_high_charts_option,
        dadttOptions: equation.default_high_charts_option,
        dadt1tOptionsFM: equation.default_high_charts_option,
        dadt1tOptionsFwo: equation.default_high_charts_option,
        dadt1tOptionsKas: equation.default_high_charts_option,
        preFactorOptions: equation.default_high_charts_option
      }
    },
    methods: {
      onSelectChange(val) {
          if(val > KNOWN_REACTION_LEVEL_FUN_IDX) {
              this.showMNInput = true;
          } else {
            this.showMNInput = false;
          }
      },
      exportData (type) {
        if (type === 1) {
          this.$refs.table1.exportCsv({
            filename: 'Ea',
            columns: this.columnsEa,
            data: this.dataEa
          });
        } else if (type === 2) {
          this.$refs.table2.exportCsv({
            filename: 'lnA',
            columns: this.columnsLnA,
            data: this.dataLnA
          });
        }
      },
      addHeatingRate() {
        this.$store.dispatch('AddHeatRate').then(() => {
          this.$Message.info('添加升温速率成功');
        }).catch(() => {
          this.$Message.info('添加升温速率失败');
        })
      },
      removeHeatingRate( heatRate ){
        this.$store.dispatch('RemoveHeatRate', heatRate).then(() => {
          this.$Message.info('删除升温速率成功');
        }).catch(() => {
          this.$Message.info('删除升温速率失败');
        })
      },
      handleSelectedFile ( convertedData ) {
        this.$store.dispatch('UpdateHeatingRateRawData', convertedData).then(() => {
          this.$Message.info('导入升温速率数据成功');
        }).catch(() => {
          this.$Message.error('导入升温速率数据失败');
        });

      },
      calculateErFwo( convRate, e, kDadtes, precision) {
        let slopDataes = [];
        kDadtes.map( item => {
          let x = 1000/item.data.temperatureK;
          let hx = calculateHxFwo(e, item.data.temperatureK);
          let y = Math.log10(item.heatRate) / hx;
          slopDataes.push([x, y]);
        });

        let line = fitLine(slopDataes);
        let er = -CONST_R * line.a * 1000 / B1;
        let v = Math.abs(er - e) / e;
        if (!v) {
          return er;
        }
        console.log(v);
        if(v < precision) {
          return er;
        } else {
          return this.calculateErFwo(convRate, er, kDadtes, precision)
        }
      },
      calculateErKas( convRate, e, kDadtes) {
        let slopDataes = [];
        kDadtes.map( item => {
          let x = 1000/item.data.temperatureK;
          let hx = calculateHxKas(e, item.data.temperatureK);
          let phtt = item.heatRate / (hx * Math.pow(item.data.temperatureK, 2));
          let y = Math.log(phtt);
          slopDataes.push([x, y]);
        });

        let line = fitLine(slopDataes);
        let er = -CONST_R * line.a * 1000;
        let v = Math.abs(er - e) / e;
        if(v < 0.01) {
          return er;
        } else {
          return this.calculateErKas(convRate, er, kDadtes)
        }
      },
      handleCal() {
        let tgSeries = [];
        let dtgSeries = [];
        let conversionRateSeries = [];
        let dadtSeries = [];

        this.heatRates.map(item => {
          let tgSeriesData = [];
          let dtgSeriesData = [];
          let convRateSeriesData = [];
          let dadtSeriesData = [];

          item.rawData.map(rItem => {
            tgSeriesData.push([ rItem.temperature, rItem.weightP ]);
            dtgSeriesData.push([ rItem.temperature, rItem.dWeight ]);
            convRateSeriesData.push([ rItem.temperature, rItem.conversionRate ]);
            dadtSeriesData.push([ rItem.temperature, rItem.dadt ])
          });

          tgSeries.push({ name: item.heatRate + '℃/min', data: tgSeriesData });
          dtgSeries.push({ name: item.heatRate + '℃/min', data: dtgSeriesData });
          conversionRateSeries.push({ name: item.heatRate + '℃/min', data: convRateSeriesData });
          dadtSeries.push({ name: item.heatRate + '℃/min', data: dadtSeriesData });
        });

        let dadt_1_TSeriesFM = [];  //dα/dt-1/T图
        let dadt_1_TSeriesFwo = [];  //dα/dt-1/T图
        let dadt_1_TSeriesKas = [];  //dα/dt-1/T图

        let erxAxisData = [];
        let erSeriesDataFwo = [];
        let erSeriesDataKas = [];
        let e0SeriesDataFM = [];

        let lnASeriesDataFwo = [];
        let lnASeriesDataKas = [];
        let lnASeriesDataFM = [];

        let lineBDatasFM = []; //Friedman截距

        for (let convRate = this.convRate.min; convRate <= this.convRate.max; convRate += this.convRate.step) {
          let kDadtes = fetchNearestRateDatasForFixedRate(this.heatRates, convRate);
          let fixedConvRate = convRate.toFixed(3);
          erxAxisData.push(fixedConvRate);
          let middleRawData = null;
          kDadtes.map( item => {
            if(item.heatRate === this.middleHeatRate) {
              middleRawData = item.data;
            }
          });
          if(middleRawData === null) {
            this.$Message.error('中间升温速率错误！');
            return;
          }

          //Friedman
          let slopDataesFM = fetchFMSlopDatasForFixedRate(kDadtes);
          dadt_1_TSeriesFM.push({ name: fixedConvRate, data: slopDataesFM });
          let lineFM = fitLine(slopDataesFM);
          e0SeriesDataFM.push(-lineFM.a * CONST_R);  //这里不乘以1000，因为纵坐标单位为KJ/mol
          lnASeriesDataFM.push(lineFM.b - Math.log(this.jilifuncs[this.reactionFunc].diff(convRate, this.jilifuncValueM, this.jilifuncValueN)));
          lineBDatasFM.push(lineFM.b);

          //机理方程积分形式g(a)
          let temp1Kas = this.jilifuncs[this.reactionFunc].integ(convRate, this.jilifuncValueM, this.jilifuncValueN);
          //FWO
          let slopDataesFwo = fetchFwoSlopDatasForFixedRate(kDadtes);
          dadt_1_TSeriesFwo.push({ name: fixedConvRate, data: slopDataesFwo });
          let lineFwo = fitLine(slopDataesFwo);
          let e0Fwo = -CONST_R * lineFwo.a * 1000 / B1;
          let erFwo = this.calculateErFwo(convRate, e0Fwo, kDadtes, 0.01);
          if (!erFwo) {
            erFwo = this.calculateErFwo(convRate, e0Fwo, kDadtes, 0.05);
          }
          if (!erFwo) {
            erFwo = this.calculateErFwo(convRate, e0Fwo, kDadtes, 0.1);
          }

          erSeriesDataFwo.push(erFwo/1000);
          let tempFwo = this.middleHeatRate * CONST_R * temp1Kas / erFwo;
          let logAFwo = Math.log10(tempFwo) + 2.315 + B1 * erFwo / (CONST_R * middleRawData.temperatureK);
          const lnAFwo = logAFwo * Math.log(10);
          lnASeriesDataFwo.push(lnAFwo);

          //KAS
          let slopDataesKas = fetchKasSlopDatasForFixedRate(kDadtes);
          dadt_1_TSeriesKas.push({ name: fixedConvRate, data: slopDataesKas });
          let lineKas = fitLine(slopDataesKas);
          let e0Kas = -CONST_R * lineKas.a * 1000;
          let erKas = this.calculateErKas(convRate, e0Kas, kDadtes);
          erSeriesDataKas.push(erKas/1000);
          let temp0Kas = Math.pow(middleRawData.temperatureK, 2);
          let lnAKas = Math.log(this.middleHeatRate/temp0Kas) + erKas/(CONST_R * middleRawData.temperatureK) - Math.log(erKas/(CONST_R*temp1Kas));
          lnASeriesDataKas.push(lnAKas);
        }

        window.console.log(erSeriesDataFwo);
        window.console.log(erSeriesDataKas);
        window.console.log(e0SeriesDataFM);

        this.tgOptions = this.generateOption('TG图', '温度(°C)', '重量(%)', tgSeries);

        this.dtgOptions = this.generateOption('DTG图', '温度(°C)', '重量微分(%/°C)', dtgSeries);
        this.convRateOptions = this.generateOption('转化率', '温度(°C)', '转化率', conversionRateSeries);
        this.dadttOptions = this.generateOption('dα/dt-T图', '温度(°C)', 'dα/dt', dadtSeries);
        this.dadt1tOptionsFM = this.generateOption('Friedman斜率图', '1000/T', 'Log(β)', dadt_1_TSeriesFM);
        this.dadt1tOptionsFwo = this.generateOption('FWO斜率图', '1000/T', 'Log(β)', dadt_1_TSeriesFwo);
        this.dadt1tOptionsKas = this.generateOption('KAS斜率图', '1000/T', 'Log(β)', dadt_1_TSeriesKas);

        this.e0Options = this.generateE0Option(erxAxisData, [
          { name: 'FWO', data: erSeriesDataFwo },
          {name: 'KAS', data: erSeriesDataKas},
          {name: 'Friedman', data: e0SeriesDataFM }]);


        let nLnAnFM = calculateLnAandNForFuntion43(erxAxisData, lineBDatasFM, erxAxisData.length);
        let subTitle = 'Friedman 机理方程编号43拟合出的n=' + nLnAnFM.a + ', ln(A)值=' + nLnAnFM.b;
        this.preFactorOptions = this.generateLnAOption(subTitle, erxAxisData, [ {
          name: 'FWO-lnA',
          data: lnASeriesDataFwo
        }, {
            name: 'KAS-lnA',
            data: lnASeriesDataKas
        }, {
          name: 'Friedman-lnA',
          data: lnASeriesDataFM
        }]);
      },
      calculate() {
        for (let i = 0; i < this.heatRates.length; ++i) {
          if(!this.heatRates[i].init) {
            this.$Modal.info({
              title: '实验数据未导入'
            });
            return;
          }
        }

        this.loading = true;
        this.disableCalculateJili = true;
        new Promise( (resolve, reject) => {
          let self_ = this;
          setTimeout(function () {
            try {
              self_.handleCal();
              resolve();
            } catch (e) {
              window.console.log(e);
              reject(e)
            }
          }, 500);
        }).then(() => {
          this.$Message.success('计算完成');
          this.loading = false;
          this.disableCalculateJili = false;
        }).catch((e) => {
          this.loading = false;
          this.disableCalculateJili = false;
          window.console.log(e);
          this.$Modal.error({
            title: '运算失败',
            content: e.toString()
          });
        }).finally(() => {
          this.loading = false;
          this.disableCalculateJili = false;
        });
      },
      handleCalJili() {
        this.dataEa = [];
        this.dataLnA = [];

        this.heatRates.map( item => {
          let result = this.handleCalJiliForOneHeatRate(item);

          let tempEa = this.dataEa.concat(result.absEaData);
          let tempLnA = this.dataLnA.concat(result.absLnAData);
          this.dataEa = tempEa;
          this.dataLnA = tempLnA;
        });

        window.console.log(this.dataEa);
        window.console.log(this.dataLnA);
      },
      handleCalJiliForOneHeatRate(item) {
        let convDadtes = [];
        let currentHeatRate;
        for (let convRate = this.convRate.min; convRate <= this.convRate.max; convRate += this.convRate.step) {
//          let kDadtes = fetchNearestRateDatasForFixedRate(this.heatRates, convRate);
          let rateData = nearestRateData(item.rawData, convRate);

          let temperateK = rateData.temperatureK;
          let dadt = rateData.dadt;
          let revertTempK = 1.0 / temperateK;
          let temp = Math.pow(temperateK, 2);

          currentHeatRate = item.heatRate;
          convDadtes.push({convRate: convRate, dadt: dadt, revertTempK: revertTempK, temp: temp});
        }

        let absEaDatas = [];
        let absLnADatas = [];
        equation.mechanisms.map( (mechanism, index) => {
          if(index > KNOWN_REACTION_LEVEL_FUN_IDX) {
              return;
          }
          let redfernDatas = [];
          let acharDatas = [];
          convDadtes.map( item=> {
            let ga = mechanism.integ(item.convRate);
            let fa = mechanism.diff(item.convRate);

            let redfern = Math.log(ga / item.temp);
            let achar = Math.log(1.0 / fa * item.dadt);

            redfernDatas.push([item.revertTempK, redfern]);
            acharDatas.push([item.revertTempK, achar]);
          });

          let redfernLine = fitLine(redfernDatas);
          let acharLine = fitLine(acharDatas);

          let coatsRedfernEa = -redfernLine.a * CONST_R;
          let coatsRedfernLnA = redfernLine.b + Math.log(currentHeatRate * coatsRedfernEa) - Math.log(CONST_R);

          let acharBridlySharpEa = -acharLine.a * CONST_R;
          let acharBridlySharpLnA = acharLine.b + Math.log(currentHeatRate);

          let absEa = Math.abs(coatsRedfernEa - acharBridlySharpEa);
          let absLnA = Math.abs(coatsRedfernLnA - acharBridlySharpLnA);

          absEaDatas.push({heatRate: currentHeatRate, error: absEa, name: mechanism.name});
          absLnADatas.push({heatRate: currentHeatRate, error: absLnA, name: mechanism.name});
        });

        absEaDatas.sort( (a, b) => {
          return a.error - b.error;
        });
        absLnADatas.sort( (a, b) => {
          return a.error - b.error;
        });

        return {absEaData: absEaDatas.slice(0,5), absLnAData: absLnADatas.slice(0,5)};
      },
      calculateJili() {
        for (let i = 0; i < this.heatRates.length; ++i) {
          if(!this.heatRates[i].init) {
            this.$Message.error('数据未初始化');
            return;
          }
        }

        this.loadingJili = true;
        this.disableCalculate = true;
        new Promise( (resolve, reject) => {
          let self_ = this;
          setTimeout(function () {
            try {
              self_.handleCalJili();
              resolve();
            } catch (e) {
              reject(e)
            }
          }, 500);
        }).then(() => {
          this.$Message.success('计算完成');
          this.loadingJili = false;
          this.disableCalculate = false;
        }).catch((e) => {
          window.console.log(e);
          this.$Modal.error({
            title: '运算失败',
            content: e.toString()
          });
        }).finally(() => {
          this.loadingJili = false;
          this.disableCalculate = false;
        });
      },
      generateE0Option( xCategories, seriesData ) {
        let opt = {
          title: {
            text: '活化能E'
          },
          xAxis: {
            title: {
              text: '转化率'
            },
            categories: xCategories
          },
          credits: {
            enabled: false
          },
          yAxis: {
            title: {
              text: '活化能(KJ/mol)'
            }
          },
          series: seriesData
        };

        return opt;
      },

      generateLnAOption( subTitle, xCategories, seriesData ) {
        let opt = {
          title: {
            text: '指前因子A'
          },
          subtitle: {
            text: subTitle
          },
          xAxis: {
            title: {
              text: '转化率'
            },
            categories: xCategories
          },
          credits: {
            enabled: false
          },
          yAxis: {
            title: {
              text: '指前因子对数(min-1)'
            }
          },
          series: seriesData
        };

        return opt;
      },
      generateOption( title, xTitle, yTitle, seriesData ) {
        let opt = {
          chart: {
            type: 'spline'
          },
          title: {
            text: title
          },
          subtitle: {
            text: null
          },
          credits: {
            enabled: false
          },
          xAxis: {
            title: {
              text: xTitle
            }
          },
          yAxis: {
            title: {
              text: yTitle
            }
          },
          tooltip: {
            headerFormat: '<b>{series.name}</b><br>',
            pointFormat: '{point.x:.2f}: {point.y:.2f}'
          },
          plotOptions: {
            series: {
              events: {
                legendItemClick: function () {
                  return false;
                }
              }
            }
          },
          series: seriesData || []
        };

        return opt;
      },
      handleAuthor() {
        this.$Modal.info({
          title: '',
          content: '<p style="text-align: left">本软件由中国林业科学研究院木材工业研究所博士后，北京林业大学副教授漆楚生研发，联系邮箱：qichusheng@bjfu.edu.cn</p>'
        });
      }
    }
  }
</script>

<style scoped>
  .dashboard {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    background-size: 100% 100%
  }

  .flex-container.column {
    position: relative;
    height: 90%;
    width: 90%;
    overflow: hidden;
    margin: 0 auto 100px auto;
    box-sizing: content-box;
  }

  .title {
    position: relative;
    width: 87%;
    overflow: hidden;
    margin: 10px auto;
    font-size: 24px;
    font-weight: 700;
    box-sizing: content-box;
  }

  .readme {
    float: right;
    font-size: 12px;
    font-weight: 200;
    margin: 20px 5px 0 0;
  }

  .item {
    padding: 0px;
    margin: 0px;
    width: 68%;
    height: 100%;
    position: absolute;
    text-align: center;
    transition: all 0.8s;
  }

  .input {
    min-height: 500px;
    height: 700px;
    min-width: 300px;
    width: 30%;
  }

  .output {
    height: 700px;
    transform: translate(44%, 0)
  }

  .border1 {
    margin: 5px 0;
    padding: 5px;
    border: 1px solid lightblue;
  }

  .chart-container {
    min-height: 400px;
    height: 600px;
    min-width: 400px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// dashboard.vue?36454d7b